export const сountryPropertyListDict = {
  country: {
    en: 'Country',
    de: 'Land',
    ru: 'Страна',
    tr: 'Ülke',
  },
  timeRequired: {
    en: 'Obtaining time',
    de: 'Zeit gewinnen',
    ru: 'Срок получения',
    tr: 'Elde etme süresi',
  },
  investments: {
    en: 'Property investments',
    de: 'Immobilieninvestitionen',
    ru: 'Инвестиции в недвижимость',
    tr: 'Gayrimenkul yatırımları',
  },
  benefits: {
    en: 'Benefits',
    de: 'Vorteile',
    ru: 'Преимущества статуса',
    tr: 'Faydalar',
  },
  status: {
    en: 'Status',
    de: 'Status',
    ru: 'Статус',
    tr: 'Durum',
  },
};
